import { render, staticRenderFns } from "./PurchaseIndex.vue?vue&type=template&id=a8dd66d2&scoped=true&"
import script from "./PurchaseIndex.vue?vue&type=script&lang=js&"
export * from "./PurchaseIndex.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseIndex.vue?vue&type=style&index=0&id=a8dd66d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8dd66d2",
  null
  
)

export default component.exports